import { component } from 'picoapp';
import { throttle } from 'lodash';
import { SwiperOptions } from 'swiper/types/swiper-options';

export default component(async (node) => {
  const scrollElement = node.querySelector('[hide-scrollbar]');

  const calculateGradient = () => {
    const width = scrollElement.scrollWidth - scrollElement.clientWidth;
    if (width > 0) {
      const { scrollLeft } = scrollElement;
      const diff = 100 * (scrollLeft / width);
      if (diff > 75) {
        node.setAttribute('data-show-after', 'false');
      } else {
        node.setAttribute('data-show-after', 'true');
      }
    }
  };

  const initSwiper = async () => {
    const Swiper = (await import(
      /* webpackChunkName: "swiper" */
      'modules/swiper'
    )).default;

    const swiperParams:SwiperOptions = {
      init: false,
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: {
        enabled: true,
        minimumVelocity: 0,
      },
    };

    const carousel = new Swiper(node, swiperParams);
    carousel.init();
  };

  if (window.innerWidth < 768) {
    calculateGradient();
    scrollElement.addEventListener('scroll', throttle(() => {
      calculateGradient();
    }, 100));
  } else {
    initSwiper();
  }
});
